import { LoggedInUser } from '@ipensii/shared/domain-shared';

export interface LoggedInUserState {
  user?: LoggedInUser;
  error?: Error;
}

export const initialLoggedInUserState = {};
